import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
}                        from '@angular/core';
import { BaseComponent } from '@core/bases/base-component/base.component';
import {
	DateRangeFilterType,
	FilterDateRangePickerType,
	IFilter
}                        from '@shared/list-operations/model/filter.model';
import {
	IResetEvent,
	ListOperationsResetModeEnum
}                        from '@shared/list-operations/model/list-operations.model';
import { Observable }    from 'rxjs';
import { takeUntil }     from 'rxjs/operators';

@Component( {
	selector: 'app-date-range-picker-filter',
	templateUrl: './date-range-picker-filter.component.html',
	styleUrls: [ './date-range-picker-filter.component.scss' ]
} )

export class DateRangePickerFilterComponent extends BaseComponent implements OnInit {

	private _blockEmit: boolean;
	private _dateValue: FilterDateRangePickerType;
	private businessDateFrom: Date = undefined;
	private businessDateTo: Date = undefined;

	@Input() defaultFilterData: IFilter;

	@Input() shouldReset: Observable<IResetEvent>;

	@Output() change: EventEmitter<FilterDateRangePickerType> = new EventEmitter();

	toDateMinimum: Date;
	dateRangeType = DateRangeFilterType;

	resetFromDate: EventEmitter<IResetEvent> = new EventEmitter<IResetEvent>();
	resetToDate: EventEmitter<IResetEvent> = new EventEmitter<IResetEvent>();

	constructor() {
		super();
	}

	private emitFilterItemChange(): void {
		if ( !this._blockEmit ) {
			this.change.emit( this._dateValue );
		}
	}

	ngOnInit(): void {
		if ( this.defaultFilterData ) {

			// TODO will be replaced by store resetState selector
			this.shouldReset
			.pipe( takeUntil( this.ngUnsubscribe ) )
			.subscribe( ( resetEvent: IResetEvent ) => {

				// TODO service property will be obsolete and replaced by array for individual filterIdentifiers of a (currently not finally specified)
				//  IListOperationsReset interface
				if ( resetEvent && resetEvent.service === this.defaultFilterData.service ) {

					this._blockEmit = resetEvent.blockEmit;

					switch ( resetEvent.resetMode ) {
						case ListOperationsResetModeEnum.CLEAR:

							this.resetFromDate.emit( resetEvent );
							this.resetToDate.emit( resetEvent );

							this.businessDateFrom = undefined;
							this.businessDateTo = undefined;
							break;

						case ListOperationsResetModeEnum.RESTORE:
							break;
					}
				}
			} );
		}
	}

	onChange( date: Date, type: DateRangeFilterType ): void {
		switch ( type ) {
			case DateRangeFilterType.FROM:
				this.businessDateFrom = date;
				if ( date instanceof Date ) {
					this.toDateMinimum = date;
				}

				if ( this.businessDateTo && date > this.businessDateTo ) {
					this.resetToDate.emit( { service: this.defaultFilterData.service, resetMode: ListOperationsResetModeEnum.CLEAR } );
					this.businessDateTo = undefined;
				}
				break;
			case DateRangeFilterType.TO:
				delete this.businessDateTo;
				this.businessDateTo = date;
				break;
		}

		this._dateValue = [ this.businessDateFrom, this.businessDateTo ];
		this.emitFilterItemChange();
	}
}

